import * as yup from "yup";
import moment from "moment";
import { minValidDate } from "../../DataEntry/Grid/gridFunctions";

export const eobFormPPValidationSchema = (contextValues = {}) => {
  const { totalPages, jobData, isAdditionalInfoOptions } = contextValues;

  const dateValidation = (fieldName) =>
    yup.string().test("date-validation", function (value) {
      const { qdx_status } = this.parent;
      const cleanDate = value?.replace("__/__/____", "");

      if (qdx_status === "INCOMPLETE") return true;

      if (!cleanDate) {
        return this.createError({ message: "Required" });
      }
      if (!moment(cleanDate, "MM/DD/YYYY", true).isValid() || !moment(cleanDate, "MM/DD/YYYY", true).isAfter(minValidDate)) {
        return this.createError({ message: "Invalid date" });
      }
      return true;
    });

  return yup.object().shape({
     overall_page_from: yup.string()
      .when("qdx_status", {
        is: (val) => val !== "INCOMPLETE",
        then: (schema) => 
          jobData?.client_level_customization?.overall_page_from
         ? schema
          .required("Invalid Page Number")
          .test("overall_page_from_validation", "Invalid Page Number", function(value) {
            const { overall_page_to } = this.parent;
            const { totalPages } = this.options.context || {};
            if(!jobData?.client_level_customization?.overall_page_from){return true }

            // Check if value is empty, zero, or invalid
            if (!value || value <= 0) {
              return false;
            }
            
            // Check if exceeds total pages
            if (value > totalPages) {
              return false;
            }
            
            // Check if from is greater than to
            if (overall_page_to && parseInt(value) > parseInt(overall_page_to)) {
              return false;
            }
            
            return true;
          })
          :schema
      }),

    overall_page_to: yup.string()
      .when("qdx_status", {
        is: (val) => val !== "INCOMPLETE",
        then: (schema) => 
        jobData?.client_level_customization?.overall_page_from
        ? schema
          .required("Invalid Page Number")
          .test("overall_page_to_validation", "Invalid Page Number", function(value) {
            const { overall_page_from } = this.parent;
            const { totalPages } = this.options.context || {};
            if(!jobData?.client_level_customization?.overall_page_to){return true }
            // Check if value is empty, zero, or invalid
            if (!value || value <= 0) {
              return false;
            }
            
            // Check if exceeds total pages  
            if (value > totalPages) {
              return false;
            }
            
            // Check if from is greater than to
            if (overall_page_from && parseInt(overall_page_from) > parseInt(value)) {
              return false;
            }
            
            return true;
          })
          :schema
      }),
    qdx_status: yup.string().when("$isAdditional", {
      is: true,
      then: (schema) => schema.when("$isAdditionalInfoOptions.status", {
        is: true,
        then: (schema) => schema.required("Required")
      })
    }),
    
    qdx_reason: yup
      .array()
      .of(yup.number().typeError("Must be a number"))
      .when(["qdx_status", "$isAdditional"], {
        is: (status, isAdditional) => isAdditional && status === "INCOMPLETE",
        then: (schema) =>
          schema.when("$isAdditionalInfoOptions.reason", {
            is: true,
            then: (schema) =>
              schema.min(1, "At least one reason is required"), // must contain numbers
            otherwise: (schema) => schema, // allow empty array
          }),
        otherwise: (schema) => schema, // allow empty array
      }),

    check_number: yup.string().when("qdx_status", {
      is: (qdxStatus) => qdxStatus !== "INCOMPLETE",
      then: (schema) => schema.required("Required"),
    }),

    check_date: dateValidation("check_date"),

    check_amount: yup.string().when("qdx_status", {
      is: (qdxStatus) => qdxStatus !== "INCOMPLETE",
      then: (schema) => schema.required("Required").test("amount-validation", "Invalid check amount", function(value) {
        const { is_check_amount } = this.parent;
        if (is_check_amount !== "" && is_check_amount !== value) {
          return false;
        }
        return true;
      }),
    }),

    payer_account_number: yup.string().when("qdx_status", {
      is: (qdxStatus) => qdxStatus !== "INCOMPLETE",
      then: (schema) => schema.required("Required"),
    }),

    patient_account_number: yup.string().when("qdx_status", {
      is: (qdxStatus) => qdxStatus !== "INCOMPLETE",
      then: (schema) => schema.required("Required"),
    }),

    statement_date: dateValidation("statement_date"),

    patient_page_from: yup.string().test("patient-page-from-validation", "Invalid Page Number", function(value) {
      const { patient_page_to,qdx_status } = this.parent;
      if (qdx_status === "INCOMPLETE") return true;
      if (totalPages > 0) {
        return value > 0 && value <= totalPages && value <= patient_page_to;
      }
      return true;
    }),

    patient_page_to: yup.string().test("patient-page-to-validation", "Invalid Page Number", function(value) {
      const { patient_page_from,qdx_status } = this.parent;
      if (qdx_status === "INCOMPLETE") return true;
      if (totalPages > 0) {
        return value > 0 && value <= totalPages && patient_page_from <= value;
      }
      return true;
    }),
  });
};